import { render } from "./ConfigInfo.vue?vue&type=template&id=ccf33df8&scoped=true&ts=true"
import script from "./ConfigInfo.vue?vue&type=script&lang=ts"
export * from "./ConfigInfo.vue?vue&type=script&lang=ts"

import "./ConfigInfo.vue?vue&type=style&index=0&id=ccf33df8&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccf33df8"]])

export default __exports__